module.exports = __webpack_public_path__ + "img/Desktop-down.de495bb6.jpg";